
const isPosItemsCategory = (category) => category?.get?.('is_pos_items') === true

export function CATEGORIES_STORE (state, categories) {
 state['all'] = categories.length > 0 ? categories.filter(category => !isPosItemsCategory(category)).sort(
  (_a,_b) => {
    const a = _a.get('index')
    const b = _b.get('index')

    return !a ? 1 : !b ? -1 : a-b
  }
 ) : []
}

export function CATEGORIES_LOADING (state, status) {
 state['loading'] = status
}

export function CATEGORIES_SET (state, category) {
 state['current'] = category
}

export function SET_COUNTED (state, { categoryId, counts }) {
 state.countedItems[categoryId] = counts
}

